module.exports = __webpack_public_path__ + "static/media/game_consoles1.7372bd3f.png";